"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 2.2.0
 */
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var form_service_1 = require("./form.service");
var interpreter_1 = require("../interpreter");
var lodash_1 = require("lodash");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var zip_1 = require("rxjs/observable/zip");
var Subject_1 = require("rxjs/Subject");
var JsonBasedFormService = /** @class */ (function (_super) {
    __extends(JsonBasedFormService, _super);
    function JsonBasedFormService(http, applicationPropertiesService, readingService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.readingService = readingService;
        _this.kbJSON = new ReplaySubject_1.ReplaySubject(1);
        _this.propsJSON = new ReplaySubject_1.ReplaySubject(1);
        _this.kbJSONKey = 'dynamic-forms-kb-json-path';
        _this.propsJSONKey = 'dynamic-forms-properties-json-path';
        _this.destroySubject$ = new Subject_1.Subject();
        _this.init();
        return _this;
    }
    JsonBasedFormService.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    JsonBasedFormService.prototype.loadForm = function (formName, formId, categoryName) {
        var _this = this;
        var typeId;
        return combineLatest_1.combineLatest(this.kbJSON, this.propsJSON).pipe(operators_1.first(), operators_1.map(function (data) {
            var layoutObject = _this.grabCorrectLayoutJson(data[0], formName, categoryName);
            typeId = layoutObject['typeId'];
            return JSON.stringify({
                layout: layoutObject['layout'],
                property: _this.grabCorrectPropertyJson(data[1], formName, categoryName),
            });
        }), operators_1.switchMap(function (layoutJson) {
            return _this.readingService.readForm(layoutJson, categoryName);
        }), operators_1.map(function (model) {
            return {
                id: undefined,
                model: model,
                type: typeId,
                description: undefined,
                formEntityTypeId: undefined,
                name: undefined,
                categorySystemName: categoryName,
                subCategorySystemName: undefined,
                prefix: undefined,
            };
        }));
    };
    JsonBasedFormService.prototype.addNewForm = function (formData) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedFormService.prototype.updateForm = function (formDtoModel) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedFormService.prototype.removeForm = function (formId) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedFormService.prototype.allSubFormsByCategoryAndType = function (categoryName, subCategoryName, type) {
        throw new Error('Method not implemented.');
    };
    JsonBasedFormService.prototype.allFormsByCategoryAndType = function (categoryName, type) {
        var _this = this;
        return combineLatest_1.combineLatest(this.kbJSON, this.propsJSON).pipe(operators_1.first(), operators_1.switchMap(function (data) {
            var kb = JSON.parse(data[0]);
            var obj = JSON.stringify({
                layout: data[0],
                property: data[1],
            });
            return zip_1.zip.apply(void 0, Object.keys(kb[categoryName].forms)
                .filter(function (form) {
                return kb[categoryName].forms[form].typeId === type;
            })
                .map(function (form) {
                return _this.createDeFormModel(categoryName, form, data[0], data[1]);
            }));
        }));
    };
    JsonBasedFormService.prototype.loadFormTypeId = function (formName, formId, categoryName) {
        var _this = this;
        return combineLatest_1.combineLatest(this.kbJSON, this.propsJSON).pipe(operators_1.first(), operators_1.map(function (data) {
            var layoutObject = _this.grabCorrectLayoutJson(data[0], formName, categoryName);
            return layoutObject['typeId'];
        }));
    };
    JsonBasedFormService.prototype.updateFormJson = function (formDtoModel) {
        throw new Error('Method not implemented.');
    };
    JsonBasedFormService.prototype.fullUpdateForm = function (formDtoModel) {
        throw new Error('Method not implemented.');
    };
    JsonBasedFormService.prototype.grabCorrectLayoutJson = function (layoutJson, formName, categoryName) {
        var parsedLayout = JSON.parse(layoutJson);
        var typeId = parsedLayout[categoryName]['forms'][formName]['typeId'];
        var layout = {};
        layout[categoryName] = {
            forms: lodash_1.pick(parsedLayout[categoryName]['forms'], [formName]),
        };
        return { layout: JSON.stringify(layout), typeId: typeId };
    };
    JsonBasedFormService.prototype.grabCorrectPropertyJson = function (propJson, formName, categoryName) {
        var prop = {};
        prop[categoryName] = lodash_1.pick(JSON.parse(propJson)[categoryName], [
            formName,
        ]);
        return JSON.stringify(prop);
    };
    JsonBasedFormService.prototype.init = function () {
        var _this = this;
        this.applicationPropertiesService
            .getProperty(this.kbJSONKey)
            .then(function (path) {
            return _this.http
                .get(path)
                .pipe(operators_1.takeUntil(_this.destroySubject$))
                .subscribe(function (data) {
                return _this.kbJSON.next(JSON.stringify(data));
            }, function (error) { return console.error(error); });
        });
        this.applicationPropertiesService
            .getProperty(this.propsJSONKey)
            .then(function (path) {
            return _this.http
                .get(path)
                .pipe(operators_1.takeUntil(_this.destroySubject$))
                .subscribe(function (data) {
                return _this.propsJSON.next(JSON.stringify(data));
            }, function (error) { return console.error(error); });
        });
    };
    JsonBasedFormService.prototype.createDeFormModel = function (categorySystemName, formName, kbJSON, propsJSON) {
        var layoutObject = this.grabCorrectLayoutJson(kbJSON, formName, categorySystemName);
        var typeId = layoutObject['typeId'];
        var data = JSON.stringify({
            layout: layoutObject['layout'],
            property: this.grabCorrectPropertyJson(propsJSON, formName, categorySystemName),
        });
        return this.readingService.readForm(data, categorySystemName).pipe(operators_1.map(function (layoutModel) {
            return {
                id: undefined,
                type: typeId,
                model: layoutModel,
                description: undefined,
                formEntityTypeId: undefined,
                name: undefined,
                categorySystemName: categorySystemName,
                subCategorySystemName: undefined,
                prefix: undefined,
            };
        }));
    };
    JsonBasedFormService.prototype.createPageModel = function (formName, kbJSON, propsJSON) {
        var data = JSON.stringify({
            layout: kbJSON,
            property: propsJSON,
        });
        return this.readingService.readForm(JSON.stringify(data), null).pipe(operators_1.map(function (layoutModel) {
            return {
                id: undefined,
                type: undefined,
                model: layoutModel,
                description: undefined,
                formEntityTypeId: undefined,
                name: undefined,
                categorySystemName: layoutModel
                    ? layoutModel.category
                    : undefined,
                subCategorySystemName: undefined,
                prefix: undefined,
            };
        }));
    };
    JsonBasedFormService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            interpreter_1.LayoutReadingService])
    ], JsonBasedFormService);
    return JsonBasedFormService;
}(form_service_1.FormService));
exports.JsonBasedFormService = JsonBasedFormService;
//# sourceMappingURL=json-based-form.service.js.map